export const actionType = {
  UPDATE_LOADER_STATE: "UPDATE_LOADER_STATE",
};
